import { loadScriptOnIntent } from "../../../scripts/utils/utils";

const fitmix = document.getElementById("fitmix-container");
const productTemplateContainer = document.querySelector('[data-section-type="product-template"]');
let productTryOnButton = document.querySelector('.try-on-product-button');

if (!fitmix || !productTemplateContainer || !productTryOnButton) return;

let frameId = productTryOnButton?.dataset?.frameId;
const lang = productTryOnButton?.dataset?.lang;
let pendingAction = null;

let params = {
  apiKey: 'FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt',
  lang: lang ? lang : 'en',
  frame: frameId,
  onStopVto: hide,
  watermark: false,
  uiConfiguration: {
    liveRelaunchDetectionButton: false,
    livePhotoButton: false
  }
};

async function initFitMix() {
  try {
    productTryOnButton.setAttribute('aria-disabled', 'true');

    await loadScriptOnIntent(
      'https://vto-advanced-integration-api.fittingbox.com/index.js',
      productTryOnButton,
      {
        mobile: 'hover',
        desktop: 'hover',
        idleTimeout: 3000,
        checkGlobal: 'FitMix',
        sessionKey: 'fitmix_interaction',
        enableClickIntent: true
      }
    );

    fitmixInstance = FitMix.createWidget('fitmix-container',
      params,
      function () {
        productTryOnButton.setAttribute('aria-disabled', 'false');

        if (pendingAction === 'open') {
          openVto();
          pendingAction = null;
        }
      }
    );
  } catch (error) {
    productTryOnButton.setAttribute('aria-disabled', 'false');
  }
}

initFitMix();

function hide() {
  fitmix.style.display = 'none';

  if (productTemplateContainer)
    productTemplateContainer.classList.remove('try-on-enabled');
}

function show() {
  fitmix.style.display = 'block';

  if (productTemplateContainer)
    productTemplateContainer.classList.add('try-on-enabled');
}

function openVto() {
  sessionStorage.setItem('fitmix_interaction', 'true');
  fitmixInstance.startVto('live');
  show();
}

function stopVto() {
  fitmixInstance.stopVto();

  const resizeFlickityEvent = new CustomEvent('product:try-on:closed');
  document.dispatchEvent(resizeFlickityEvent);
}

function toggleTryOn() {
  sessionStorage.setItem('fitmix_interaction', 'true');

  if (productTryOnButton.getAttribute('aria-disabled') === 'true') {
    pendingAction = 'open';
    return;
  }

  if (!productTemplateContainer?.classList.contains('try-on-enabled')) {
    openVto();
  } else {
    stopVto();
  }
}

function setTryOnBtnEvent() {
  if (productTryOnButton) {
    productTryOnButton.addEventListener('click', toggleTryOn);
  }
}

document.addEventListener('product-variant-switch:end', () => {
  initTryOnButton();
  setTryOnFrame();
});

function initTryOnButton() {
  productTryOnButton = document.querySelector('.try-on-product-button');
  if (productTryOnButton?.dataset?.frameId) setTryOnBtnEvent();
}

function setTryOnFrame() {
  frameId = productTryOnButton?.dataset?.frameId;

  if (!frameId) {
    stopVto();
  } else {
    fitmixInstance?.setFrame(frameId);
  }
}

setTryOnBtnEvent();